import React from 'react';
import './Chatbox.css';
import SelectedTextPanel from './SelectedTextPanel';
import ChatUI from './ChatUI';

const Chatbox = ({ selectedText, fullPDFText, activePdfName, isDarkMode, isAuthenticated = true, onLogin }) => {
  return (
    <div className={`flex h-full relative overflow-hidden ${isDarkMode ? 'bg-[#0d1117]' : 'bg-gray-50'}`}>
      {/* Content */}
      <div className={`relative z-10 flex w-full h-full ${isDarkMode ? 'bg-[#0d1117]' : 'bg-gray-50'}`}>
        <div className="w-1/2 min-w-[250px] flex-shrink-0 overflow-hidden">
          <SelectedTextPanel
            selectedText={selectedText}
            fullPDFText={fullPDFText}
            isDarkMode={isDarkMode}
            isAuthenticated={isAuthenticated}
            onLogin={onLogin}
          />
        </div>
        {/* Vertical separator - refined */}
        <div className={`w-px flex-shrink-0 ${isDarkMode ? 'bg-[#21262d]' : 'bg-gray-200/80'}`}></div>
        <div className="w-1/2 min-w-[250px] flex-grow overflow-hidden">
          <ChatUI
            fullPDFText={fullPDFText}
            activePdfName={activePdfName}
            isDarkMode={isDarkMode}
            isAuthenticated={isAuthenticated}
            onLogin={onLogin}
          />
        </div>
      </div>
    </div>
  );
};

export default Chatbox;
